module.exports = __webpack_public_path__ + "img/google-g.8b6324b1.svg";